<template>
  <div class="venueList" :class="$store.state.isMobile ? 'h5' : ''">
  	<div class="header"></div>
  	<div class="title">请选择一个你想参观的场馆</div>
  	<ul>
  		<li v-for="item in ticketList" :key="item.id">
  			<img :src="imageStateUrl + item.museumImg">
  			<div class="right">
  				<div>场馆名称：{{item.ticketName}}</div>
	  			<div>{{item.address ? `场馆地址：${item.address}` : ''}}</div>
	  			<div class="button3" @click="toHome(item.id)">点击进入</div>
  			</div>
  		</li>
  	</ul>
  </div>
</template>

<script>

export default {
  data() {
    return {
    	ticketList: [],
    	imageStateUrl: ''
    };
  },

  methods: {
    gettickets() {
      this.$ajax.get(`/api/ticket/front/ticket-info?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`).then((res) => {
        this.ticketList = res.data.filter((item) =>{return item.publish}).map((item) =>{
        	item.museumImg = item.museumImg.split('|')[0]
        	return item
        })
        document.title = this.ticketList[0].ticketName
      })
    },

    toHome(id) {
    	let query = this.$route.query
    	query.id = id
    	this.$router.push({name: 'home', query})
    }
  },

  created() {
  	this.imageStateUrl = !isNaN(Number(this.$route.query.museumCode)) ? '' : Glob.imgUrl
    this.gettickets()
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
	.venueList{
		.title{
			margin: 0.2rem 0;
		}
		.header{
			height: 0.5rem;
    	position: fixed;
    	top: 0;
    	left: 0;
    	z-index: 2;
    	width: 100%;
		}
		.title{
			margin-top: 0.8rem;
			font-size: 0.2rem;
		}
		ul{
			padding: 0;
		}
		ul li{
			list-style: none;
			position: relative;
			width: 6.5rem;
			margin: auto;
			line-height: 0.25rem;
			margin-bottom: 0.3rem;
			height: 1.5rem;
			img{
				width: 2.5rem;
				height: 1.5rem;
				float: left;
			}
			.right{
				float: right;
				margin-top: 0.15rem;
				width: 3.5rem;
				margin-left: 0.5rem;
				div:nth-child(1) {
					text-align: left;
					font-size: 0.15rem;
					font-weight: bold;
				}
				div:nth-child(2){
					text-align: left;
					height: 0.4rem;
					font-size: 0.12rem;
					line-height: 0.2rem;
					overflow: hidden;
					margin-bottom: 0.1rem;
				}
				.button3{
					font-size: 0.15rem;
					// margin-top: 0.1rem;
					// width: 1.5rem;
					// height: 0.36rem;
					// line-height: 0.36rem;
				}
			}
		}
		&.h5{
			.header{
				height: 1rem;
			}
			.title{
				margin-top: 1.5rem;
				font-size: 0.5rem;
			}
			ul{
				margin-top: 1rem;
			}
			ul li{
				width: calc(100% - 0.5rem);
				padding: 0 0.5rem;
				min-height: 3rem;
				max-height: 4.5rem;
				padding-bottom: 0.5rem;
				border-bottom: 1px dashed #0003;
				img{
					width: 2.7rem;
					height: 1.8rem;
					margin-top: 0.2rem;
				}
				.right{
					width: calc(100% - 3.2rem);
					div:nth-child(1) {
						font-size: 0.38rem;
						line-height: 0.6rem;
					}
					div:nth-child(2){
						font-size: 0.36rem;
						height: auto;
						max-height: 1rem;
						min-height: 0.6rem;
						line-height: 0.45rem;
						margin-top: 0.2rem;
						margin-bottom: 0.2rem;
					}
					.button3{
						font-size: 0.3rem;
						width: 3.8rem;
						height: 0.9rem;
						line-height: 0.9rem;
					}
				}
			}
		}
	}
</style>








